export const getCategories = (state) => {
  if (!state.categoriesList.categories) {
    return []
  }

  return state.categoriesList.categories
}
